const getFontSize = (base: number, scale: string) => {
  const n = parseFloat(scale);
  const multiplier = isNaN(n) || n <= 0 ? 1 : n;
  return Math.min(Math.round(base * multiplier), 300);
};

export default getFontSize;
